import user from './user'
import admin from './admin'
import profile from './profile'

export default {
  user,
  admin,
  profile,
}
